import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteBroker($id: ID!) {
        deleteBroker(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
